"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.largeScreenFontSizes = exports.smallScreenFontSizes = void 0;
/**
 * The split between small and large font styles is necessary because font styles differ slightly for sizes “large and above”. This results in some duplication, as the small and medium sizes are identical for both small and large devices.
 */
exports.smallScreenFontSizes = {
    small: {
        lineHeight: "1.25rem",
        fontSize: "0.875rem",
    },
    medium: {
        lineHeight: "1.5rem",
        fontSize: "1rem",
    },
    large: {
        lineHeight: "1.75rem",
        fontSize: "1.125rem",
    },
    xlarge: {
        lineHeight: "2rem",
        fontSize: "1.25rem",
        fontWeight: "bold",
    },
    xxlarge: {
        lineHeight: "2.25rem",
        fontSize: "1.5rem",
        fontWeight: "bold",
    },
    xxxlarge: {
        lineHeight: "2.5rem",
        fontSize: "2rem",
        fontWeight: "bold",
    },
};
exports.largeScreenFontSizes = {
    small: {
        lineHeight: "1.25rem",
        fontSize: "0.875rem",
    },
    medium: {
        lineHeight: "1.5rem",
        fontSize: "1rem",
    },
    large: {
        lineHeight: "2rem",
        fontSize: "1.25rem",
    },
    xlarge: {
        lineHeight: "2.25rem",
        fontSize: "1.5rem",
        fontWeight: "bold",
    },
    xxlarge: {
        lineHeight: "2.5rem",
        fontSize: "2rem",
        fontWeight: "bold",
    },
    xxxlarge: {
        lineHeight: "3.75rem",
        fontSize: "2.5rem",
        fontWeight: "bold",
    },
};
//# sourceMappingURL=Text.constants.js.map